module.exports = __webpack_public_path__ + "img/03logo-wss2021.b7326f13.png";